import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export default function SettingsPage() {
  const [settings, setSettings] = useState({
    theme: 'system',
    language: 'zh-CN',
    notifications: true,
    apiKey: '',
    apiEndpoint: 'http://localhost:8080',
  });

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">设置</h2>
        <p className="text-sm text-muted-foreground mt-1">管理系统配置和偏好设置</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>外观设置</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label>主题</Label>
              <div className="flex gap-2">
                <Button
                  variant={settings.theme === 'light' ? 'default' : 'outline'}
                  size="sm"
                  onClick={() => setSettings({ ...settings, theme: 'light' })}
                >
                  浅色
                </Button>
                <Button
                  variant={settings.theme === 'dark' ? 'default' : 'outline'}
                  size="sm"
                  onClick={() => setSettings({ ...settings, theme: 'dark' })}
                >
                  深色
                </Button>
                <Button
                  variant={settings.theme === 'system' ? 'default' : 'outline'}
                  size="sm"
                  onClick={() => setSettings({ ...settings, theme: 'system' })}
                >
                  跟随系统
                </Button>
              </div>
            </div>
            <div className="space-y-2">
              <Label>语言</Label>
              <select
                className="w-full px-3 py-2 border rounded-lg bg-background"
                value={settings.language}
                onChange={(e) => setSettings({ ...settings, language: e.target.value })}
              >
                <option value="zh-CN">简体中文</option>
                <option value="en-US">English</option>
              </select>
            </div>
            <div className="flex items-center justify-between">
              <Label>通知</Label>
              <Button
                variant="outline"
                size="sm"
                onClick={() => setSettings({ ...settings, notifications: !settings.notifications })}
              >
                {settings.notifications ? '开启' : '关闭'}
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>API 配置</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="apiEndpoint">API 端点</Label>
              <Input
                id="apiEndpoint"
                value={settings.apiEndpoint}
                onChange={(e) => setSettings({ ...settings, apiEndpoint: e.target.value })}
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="apiKey">API Key</Label>
              <Input
                id="apiKey"
                type="password"
                value={settings.apiKey}
                onChange={(e) => setSettings({ ...settings, apiKey: e.target.value })}
                placeholder="输入 API Key"
              />
            </div>
            <Button className="w-full">保存配置</Button>
          </CardContent>
        </Card>

        <Card className="lg:col-span-2">
          <CardHeader>
            <CardTitle>关于</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
              <div>
                <span className="text-muted-foreground">版本</span>
                <p className="font-medium">1.0.0</p>
              </div>
              <div>
                <span className="text-muted-foreground">构建时间</span>
                <p className="font-medium">2024-03-20</p>
              </div>
              <div>
                <span className="text-muted-foreground">Go 版本</span>
                <p className="font-medium">1.21+</p>
              </div>
              <div>
                <span className="text-muted-foreground">React 版本</span>
                <p className="font-medium">18+</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
